/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EAccountType } from "../types/EAccountType.ts";

/**
 * @description 1 = PhysicalPerson | 2 = LegalPerson |
 */
export const eAccountTypeSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe(
    "1 = PhysicalPerson | 2 = LegalPerson | ",
  ) as unknown as ToZod<EAccountType>;
